<template>
  <div
    class="flex-1 md:flex-none flex items-start md:items-center justify-start md:justify-center px-1 md:px-3 pt-2 pb-1 md:pb-2 rounded-md text-gray-700 cursor-pointer menu-item"
    :class="{
      'opacity-50 cursor-not-allowed': disabled,
      'menu-item-active': isRouteActive,
    }"
    @click="
      () => {
        if (!disabled) {
          router.push(goto);
        }
      }
    "
    :aria-disabled="disabled"
    :aria-label="label"
    :role="'menuitem'"
    tabindex="0"
    @keydown.enter="
      () => {
        if (!disabled) {
          router.push(goto);
        }
      }
    "
    @keydown.space="
      () => {
        if (!disabled) {
          router.push(goto);
        }
      }
    "
  >
    <div
      class="flex flex-1 items-center space-x-0 md:space-x-2 md:space-y-0 flex-col md:flex-row relative"
    >
      <slot>
        <span v-if="icon" :class="'pi ' + icon"></span>
      </slot>
      <span
        class="w-full md:w-auto text-center md:text-left whitespace-normal break-words md:inline text-xs md:text-base mt-1 md:mt-0"
        >{{ label }}</span
      >
      <span
        v-if="badge && !loading"
        class="absolute md:static -top-2 -right-3 flex items-center justify-center w-5 h-5 text-xs text-white bg-red-500 rounded-full"
      >
        {{ badge }}
      </span>
      <span
        v-if="loading"
        class="absolute md:static -top-2 -right-3 flex items-center justify-center w-5 h-5 text-xs text-white bg-red-500 rounded-full"
      >
        <span class="pi pi-spin pi-spinner-dotted" />
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps, computed } from "vue";
import { useRouter } from "vue-router";

const props = defineProps({
  icon: {
    type: String,
    required: false,
    default: "",
  },
  label: {
    type: String,
    required: true,
  },
  badge: {
    type: String,
    required: false,
    default: undefined,
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  goto: {
    type: String,
    required: true,
  },
  activePrefix: {
    type: String,
    required: false,
    default: "",
  },
  loading: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const router = useRouter();

const isRouteActive = computed(() => {
  if (router.currentRoute.value.path === props.goto) {
    return true;
  } else if (props.activePrefix) {
    return router.currentRoute.value.path.startsWith(props.activePrefix);
  } else {
    return false;
  }
});
</script>
<style scoped>
.menu-item {
  border: 1px solid transparent;

  &.menu-item-active {
    background-color: #aae09f;
  }

  &:hover {
    border-color: #aae09f;
  }
}
</style>
